package uz.ferro.erp.feature.text.ui

import emotion.react.css
import react.FC
import react.dom.html.ReactHTML.p
import uz.ferro.erp.feature.text.model.DocItemType
import uz.ferro.erp.feature.text.model.TextItem
import web.cssom.em

val DocTextView = FC<DocItemProps> { props ->
    var textItems = props.item.textItems.orEmpty()
    val item = props.item
    var type = item.type
    if (item.style != null) {
        type = DocItemType.FORMATTED_TEXT
        textItems = listOf(TextItem(
            style = item.style,
            text = item.text
        ))
    }

    p {
        css {
            marginBlockStart = 0.5.em
            marginBlockEnd = 0.5.em
        }

        if (type == DocItemType.TEXT) {
            +item.text.orEmpty()
        } else if (type == DocItemType.FORMATTED_TEXT) {
            textItems.forEach {
                DocTextItemView {
                    textItem = it
                }
            }
        }
    }
}